<template>
  <div class="activity-config">
    <el-card>
      <header class="activity-config__header">活动模板配置</header>
      <div class="activity-config__search">
        <div>
          <span>状态:</span>
          <el-select filterable v-model="searchData.status" placeholder="请选择">
            <el-option v-for="item in searchConst.status" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>时区:</span>
          <el-select filterable v-model="searchData.zoneOffset" placeholder="请选择">
            <el-option v-for="item in searchConst.zoneOffset" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>是否有效:</span>
          <el-select filterable v-model="searchData.valid" placeholder="请选择">
            <el-option v-for="item in searchConst.valid" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="getActivityList">查询</el-button>
        <el-button type="success" @click="dialogShow(true)">新增</el-button>
      </div>
      <el-table :data="tableData" height="calc(100vh - 200px)" style="width: 100%" align="center">
        <el-table-column label="活动时间" width="180" align="center">
          <template #default="{ row }">
            <div><i class="el-icon-timer"></i>{{ row.startTime }}</div>
            <div>~{{ row.endTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="活动名称" align="center"></el-table-column>
        <el-table-column prop="eventCode" label="活动code" align="center"></el-table-column>
        <el-table-column prop="eventDesc" label="活动描述" align="center" width="140">

        </el-table-column>
        <el-table-column prop="url" label="活动url" align="center" width="200">
          <template #default="{ row }">
            <el-link style="font-size: 12px;" type="primary" :underline="false" :href="row.url" target="_blank">{{
              row.url }}</el-link>
            <el-button size="mini" icon="el-icon-copy-document" @click="copy(row.url)">copy</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="valid" label="是否有效" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.valid === 1">有效</el-tag>
            <el-tag type="warning" v-else>无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="activeStatus" label="活动状态" align="center">
          <template #default="{ row }">
            <el-tag type="success">{{ row.activeStatus }}</el-tag>
          </template>
        </el-table-column>
        <!-- 
        <el-table-column prop="pageInfo" label="页面信息">
        </el-table-column> -->
        <el-table-column prop="operation" label="操作" width="200" fixed="right" align="center">
          <template #default="{ row }">
            <div class="btn-box">
              <div>
                <el-button type="primary" icon="el-icon-edit" size="small"
                  @click="dialogShow(false, row)">修改</el-button>
                <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteActivity(row)">删除</el-button>
              </div>
              <div>
                <el-button type="success" icon="el-icon-pie-chart" size="small"
                  @click="getRank(row.eventCode)">排名</el-button>
                <el-button type="info" icon="el-icon-document-copy" size="small"
                  @click="copyEvent(row.eventCode)">复制</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="searchData.page"
        @current-change="getActivityList">
      </el-pagination>
    </el-card>
    <ActivityDrawer v-model="dialog.visible" :is-edit="dialog.isEdit" @submit="submitChange" :data="dialog.data"
      @rank="getActivityList">
    </ActivityDrawer>
    <ActivityRankDialog v-model="rankDialog.show" :event-code="rankDialog.eventCode">
    </ActivityRankDialog>
  </div>
</template>

<script>
import { copyToClipboard } from '@/utils/common'
import { getConstList } from '@/api/constRequest'
import { getActivityListReq, deleteActivityListReq, copyActivityReq } from '@/api/activityModelRequest'
import ActivityDrawer from '@/components/ActivityModelConfig/ActivityDrawer.vue';
import ActivityRankDialog from '@/components/ActivityModelConfig/ActivityRankDialog.vue';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
export default {
  components: {
    ActivityDrawer,
    ActivityRankDialog
  },
  data() {
    return {
      rankDialog: {
        show: false,
        eventCode: ''
      },
      total: 0,
      dialog: {
        visible: false,
        isEdit: false,
        data: {}
      },
      tableData: [],
      searchData: {
        status: 0,
        zoneOffset: '+05:30',
        valid: 1,
        page: 1
      },
      searchConst: {
        status: [
          { value: 0, label: 'ALL' },
          { value: 1, label: '未开始' },
          { value: 2, label: '进行中' },
          { value: 3, label: '已结束' }
        ],
        valid: [
          { value: -1, label: 'ALL' },
          { value: 0, label: '无效' },
          { value: 1, label: '有效' }
        ],
        zoneOffset: []
      }
    }
  },
  methods: {
    copy(text, desc = '复制成功') {
      copyToClipboard(text, desc)
    },
    async copyEvent(eventCode) {
      // this.copy(JSON.stringify(this.tableData[0]),'已复制到新增页面。')
      const res = await copyActivityReq(eventCode)
      if (res.code === 0) {
        this.copy(JSON.stringify(res.data), '已复制。')
      } else {
        this.$message.error(res.msg)
      }
    },
    getRank(eventCode) {
      this.rankDialog = {
        show: true,
        eventCode
      }
    },
    deleteActivity(info) {
      this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteActivityListReq(info)
        if (res.code === 0) {
          this.$message({ type: 'success', message: "删除成功" })
          this.getActivityList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => { });
    },
    submitChange() {
      this.dialog.visible = false
    },
    // isAdd 是否为新增
    dialogShow(isAdd, row) {
      this.dialog.isEdit = !isAdd;
      this.dialog.visible = true;
      
      if (!isAdd) {
        // 编辑模式，先检查活动状态
        if (row && row.activeStatus == '已结束') return this.$message.error('活动已结束，无法修改')
        
        if (row.joinModeInfo.conditions && row.joinModeInfo.conditions.length > 0) {
          row.joinModeInfo.conditions.forEach(item => {
            if (item.mode === 1) {
              item.value = item.value * 1000
            }
          });
        }
        this.$set(this.dialog, 'data', { ...row })
        if (row.notJoinRidSet && row.notJoinRidSet.length > 0) {
          if (row.notJoinRidSet.length > 1) {
            this.dialog.data.notJoinRidSet = row.notJoinRidSet.join(',')
          } else {
            this.dialog.data.notJoinRidSet = row.notJoinRidSet[0].toString()
          }
        }
      } else {
        // 新增模式
        this.dialog.data = {}
      }
    },
    async getActivityList() {
      const res = await getActivityListReq(this.searchData)
      if (res.code === 0) {
        this.tableData = res.data.data
        this.total = res.data.total
        this.$message({ type: 'success', message: "查询成功" })
      } else {
        this.$message.error(res.msg)
        this.tableData = []
      }
    }
  },
  async mounted() {
    const constRes = await getConstList('timeZone')
    if (constRes.code === 0) {
      this.searchConst.zoneOffset = constRes.data
      this.searchData.zoneOffset = constRes.data[0].value
    }
    this.getActivityList()
  }
}
</script>

<style scoped lang="scss">
.activity-config {
  .el-card {
    height: calc(100vh - 56px);

  }

  &__header {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  &__search {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    .el-select,
    .el-input {
      margin-left: 12px;
    }
  }
}

.btn-box {
  display: flex;
  justify-content: center;
  flex-direction: column;

  >* {
    flex: 1;
    margin-left: 0;
    margin-top: 10px;
  }
}

// .bubble {
//   width: 0;
//   word-break: break-all;
//   border-image-repeat:repeat;

//   border:100px solid transparent;

//       border-image-source: url(https://cloudcdn.waho.live/buddle/op_1704447052_game_TOP1@3x.png);
//       border-image-slice:49% 50% 50% 50% fill;

//   height: 300px;
// }
</style> 